import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RestS } from "../../rest/rest-service";
import { history } from "../../Router/History";

const INITIAL_STATE = {
  connectionStatus: [],
  error: {},
  isInProgress: false,
};

export const fetchCurrentConnections = createAsyncThunk(
  "connections/fetch",
  async (
    {
      userId = null,
      companyId = null,
    }: { userId?: string; companyId?: number },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await RestS.getIntegrationWorkspaces({
        userId: userId ? Number(userId) : null,
        companyId: companyId ? Number(companyId) : null,
      });
      return response.authenticatedWs ? response.authenticatedWs : [];
    } catch (err) {
      return rejectWithValue(err ? err : "something went wrong");
    }
  }
);

const connections = createSlice({
  name: "connections",
  initialState: INITIAL_STATE,
  reducers: {
    updateConnections: (state, action) => {
      state.connectionStatus = action.payload.data;
    },
    addConnections: (state, action) => {
      console.log("ADDING CONNECTIONS", action.payload);
      const temp = new Set(state.connectionStatus);
      temp.add(action.payload.data);

      state.connectionStatus = Array.from(temp);
    },
    deleteConnections: (state, action) => {
      const temp = new Set(state.connectionStatus);
      temp.delete(action.payload.data);
      state.connectionStatus = Array.from(temp);
    },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(fetchCurrentConnections.pending, (state) => {
    //     state.status = INITIAL_STATE.status;
    //   });
    builder.addCase(fetchCurrentConnections.fulfilled, (state, action) => {
      state.connectionStatus = action.payload;
    });
    //   builder.addCase(fetchCurrentConnections.rejected, (state, action) => {
    //     state.status = INITIAL_STATE.status;
    //     state.error = action.error.message;
    //   });
  },
});

export const { updateConnections, addConnections, deleteConnections } =
  connections.actions;

export const Connections = connections.reducer;
